import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';

const RESOURCE = 'events';

interface IDeleteEvent extends IUri {
  token?: string;
  id: string;
}

export default async function ({
  token,
  id,
}: IDeleteEvent): Promise<IHttpResponse> {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
    id: id,
  });

  return (await BaseService.Delete({
    url,
    token,
  })) as IHttpResponse;
}
